module.exports = __webpack_public_path__ + "static/Agency_Icon-2c0c1225b54748fa86788b0392c6ca22.png";